var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgPulseUn = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 17,
    viewBox: "0 0 15 17",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 8C5.167 8 4.854 7.83401 4.668 7.55502L2.965 5.00012H1C0.448 5.00012 0 4.55214 0 4.00016C0 3.44818 0.448 3.0002 1 3.0002H3.5C3.834 3.0002 4.146 3.16719 4.332 3.44518L5.376 5.01112L7.605 0.552298C7.769 0.226312 8.096 0.01432 8.461 0.000320513C8.849 -0.00867913 9.169 0.172313 9.357 0.4843L12.066 5.00012H14C14.552 5.00012 15 5.4481 15 6.00008C15 6.55206 14.552 7.00004 14 7.00004H11.5C11.149 7.00004 10.823 6.81605 10.643 6.51506L8.58 3.0772L6.395 7.44802C6.235 7.76701 5.918 7.977 5.562 7.999C5.542 8 5.521 8 5.5 8Z",
    fill: "#2D81F7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4434 10.003L10.0716 9.60923V7.03324C10.0716 6.47434 9.58828 6.02124 8.99212 6.02124C8.39596 6.02124 7.91266 6.47434 7.91266 7.03324V12.0315L6.89132 11.2281C6.43556 10.8695 5.7184 10.8989 5.29771 11.2933C4.87701 11.6877 4.9057 12.3037 5.36146 12.6623L7.91266 14.6692C7.91266 14.9402 8.13234 15.1599 8.40332 15.1599H13.8894C14.1655 15.1599 14.3894 14.936 14.3894 14.6599C14.3894 12.9941 14.3894 11.0438 14.3894 11.0073C14.3894 10.4967 13.9838 10.0662 13.4434 10.003Z",
    fill: "#2D81F7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.91357 16.5C7.91357 16.7761 8.13743 17 8.41357 17H13.8903C14.1665 17 14.3903 16.7761 14.3903 16.5C14.3903 16.3775 14.3903 16.2361 14.3903 16.08H7.91357V16.5Z",
    fill: "#2D81F7"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgPulseUn, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/pulse-un.9d46e6e8.svg";
export { ForwardRef as ReactComponent };